export default __webpack_public_path__ + "static/media/changes.7e174cba.png";